import {ReactElement, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IElementModal} from '../../../../incase-domain/elements/modal';
import {updateModal} from '../../../../store/actions/modal.actions';
import './modal.css';
import {clickedElementIdsSelector} from '../../../../store/selectors/presentation.selectors';
import {modalVisibleSelector} from '../../../../store/selectors/modal';

interface IElementModalComponentProps {
    element: IElementModal;
}

function ElementModalComponent(props: IElementModalComponentProps): ReactElement | null {
    const {element} = props;
    const {elementToClickForDisplay, selectedSlideId} = element;

    const dispatch = useDispatch();
    const modalVisible = useSelector(modalVisibleSelector);
    const clickedElementIds = useSelector(clickedElementIdsSelector);

    function shouldDisplayModal(clickedElementIds: string[], elementToClickForDisplay: string[] | undefined): boolean {
        if (!elementToClickForDisplay) return false;

        return clickedElementIds.some((element) => elementToClickForDisplay.includes(element));
    }

    useEffect(() => {
        if (modalVisible) return;

        if (shouldDisplayModal(clickedElementIds, elementToClickForDisplay)) {
            dispatch(updateModal(true, selectedSlideId, elementToClickForDisplay || []));
        }
    }, [dispatch, modalVisible, selectedSlideId, clickedElementIds, elementToClickForDisplay, element.id]);

    return null;
}

export default ElementModalComponent;
